// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__JRZX6","Current":"BuildControls__Current__2as3h","ShowNumber":"BuildControls__ShowNumber__1vu0-","OrderButton":"BuildControls__OrderButton__25lWK","enable":"BuildControls__enable__2Rhc-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Poke/BuildControls/BuildControls.css
// module id = 149
// module chunks = 0